module.exports = __webpack_public_path__ + "img/19.0b883dcc.jpg";